import { render } from "./PrimaryFormButton.vue?vue&type=template&id=2c76d52e&scoped=true"
import script from "./PrimaryFormButton.vue?vue&type=script&lang=js"
export * from "./PrimaryFormButton.vue?vue&type=script&lang=js"

import "./PrimaryFormButton.vue?vue&type=style&index=0&id=2c76d52e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c76d52e"

export default script